var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "138.24 453.59999999999997 840.24 192.23999999999998",
    style: {
      maxHeight: 500
    },
    width: 840.24,
    height: 192.23999999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_232_85)",
    d: "M255.228 475C273.553 475 288.408 489.856 288.408 508.18C288.408 526.436 273.66 541.263 255.404 541.359L223.589 541.545H223.542L219.742 541.58C218.425 541.592 217.363 542.66 217.358 543.976V601.948C217.358 604.091 214.768 605.164 213.252 603.648L155.28 545.677C153.764 544.162 154.837 541.57 156.98 541.57H212.531C213.633 541.09 214.262 539.819 213.846 538.595L154.709 479.459C153.199 477.948 154.26 475.364 156.396 475.352L216.82 475.001L216.821 475H255.228Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_232_85)",
    d: "M271.065 493.496C276.191 493.496 281.136 494.262 285.79 495.685C287.463 499.612 288.389 503.928 288.389 508.458C288.389 526.545 273.641 541.233 255.385 541.329L223.548 541.514H223.523L221.204 541.534C221.941 514.879 243.983 493.496 271.065 493.496Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_232_85)",
    d: "M255.234 475C273.559 475 288.414 489.856 288.415 508.181C288.414 517.755 284.356 526.385 277.864 532.442C268.706 503.63 234.172 482.698 199.437 475.102L216.827 475.001L216.828 475H255.234Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_232_85)",
    d: "M271.094 493.496C276.219 493.496 281.164 494.262 285.818 495.685C287.492 499.611 288.418 503.928 288.418 508.458C288.418 509.56 288.363 510.649 288.256 511.724C287.39 519.872 283.573 527.142 277.893 532.442C273.604 518.949 263.749 507.183 250.914 497.706C257.084 494.999 263.912 493.496 271.094 493.496Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_232_85)",
    d: "M182.71 541.535C183.622 560.044 190.104 577.089 200.515 591.028L155.127 545.642C153.612 544.126 154.686 541.535 156.829 541.535H182.71Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M925.889 489.005V590.354H908.142V489.005H925.889Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M883.549 548.899H845.837V590.354H828.091V489.005H890.758V505.365H845.837V532.955H883.549V548.899Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M804.239 489.005V590.354H786.492V489.005H804.239Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M699.952 590.354H682.205V489.005H699.952V530.876H744.873V489.005H762.619V590.354H744.873V547.374H699.952V590.354Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M618.457 592.018C588.926 592.018 569.793 571.498 569.793 539.749C569.793 508.276 589.619 487.341 619.289 487.341C643.275 487.341 661.16 501.344 664.626 523.111H645.909C642.443 511.326 632.322 504.394 618.873 504.394C600.156 504.394 588.371 517.981 588.371 539.61C588.371 561.1 600.295 574.964 618.873 574.964C632.599 574.964 643.136 567.755 646.464 556.525H664.903C661.021 577.876 642.443 592.018 618.457 592.018Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M487.64 505.365V489.005H564.726V505.365H535.056V590.354H517.31V505.365H487.64Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M418.562 590.354H400.122L436.724 489.005H454.887L491.489 590.354H472.772L464.592 566.923H426.742L418.562 590.354ZM443.518 519.229L432.01 551.95H459.462L447.816 519.229C446.984 516.595 446.014 513.545 445.736 511.465C445.32 513.406 444.488 516.457 443.518 519.229Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M365.376 555.416H343.055V590.354H325.308V489.005H365.376C385.757 489.005 398.929 502.315 398.929 522.141C398.929 541.69 385.619 555.416 365.376 555.416ZM361.91 504.81H343.055V539.61H361.633C373.834 539.61 380.35 533.094 380.35 522.002C380.35 510.911 373.695 504.81 361.91 504.81Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 477.406,
    x2: 135.801,
    y1: 509.272,
    x1: 309.917,
    id: "paint0_linear_232_85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D12929"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#840404",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 518.654,
    x2: 267.698,
    y1: 526.888,
    x1: 236.059,
    id: "paint1_linear_232_85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900A0A",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 502.292,
    x2: 279.728,
    y1: 490.399,
    x1: 218.604,
    id: "paint2_linear_232_85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60303"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB1818",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 491.323,
    x2: 288.182,
    y1: 505.714,
    x1: 230.116,
    id: "paint3_linear_232_85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30808",
    offset: 0.9306
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 537.431,
    x2: 204.886,
    y1: 548.314,
    x1: 133.998,
    id: "paint4_linear_232_85"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120101"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B30808",
    offset: 0.422417
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60707",
    offset: 0.547944
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360303",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/NewLogo.b613a4821e7a6e137b2c835c92e12e2c.svg";
export { ForwardRef as ReactComponent };